/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Container } from '@adobe/cq-react-editable-components';
import PropTypes from 'prop-types';

import { FWAContainer } from '../../../common/FWAContainer';
import { Row, Col } from '../../../common/Grid';
import './creditCheck.css';
import MiniCart from '../../../common/MiniCart/redesign';
import { eventDispatcher, updateUrl } from '../../../common/Tagging/index';
import Notification from '../../../common/Notification/redesign/index';
import { Margin, StyledVdsRow } from '../../../common/styles';
import {
  viewport,
  isMobile,
  isPreorder,
  getPrefetch,
  isLoggedIn,
  isTablet,
  isDesktopResolution,
  pdcAEMCheck,
  renderHTML,
  getUrlName,
  getFlowType,
} from '../../../common/Helpers';
import { lazyWithPreload } from '../../../common/Helpers/lazyWithPrefetch';
import { checkCartidAndLQResponse } from '../../../common/Helpers/commonLog';
import ContextWrapper from './Components/ContextWrapper';
import { PersonalInfoConsumer } from './personalnfoContext';
import Button from '../../../common/Button';
import { commonErrors } from '../../../common/Helpers/constants';
import { store } from '../../../../configureStore';
import { Body } from '../../../common/Typography/index';
import { getChannelId } from '../../../../services/HttpService';
import { showLoader } from '../../../common/Helpers/loader';
import { callPerformanceMeasure } from '../../../common/Helpers/performanceMeasure';

export default class CreditCheck extends Container {
  constructor(props) {
    super(props);
    checkCartidAndLQResponse('creditCheck');
    this.handleCreditCheckLoad = this.handleCreditCheckLoad.bind(this);
  }

  componentDidMount() {
    window.addEventListener('load', this.handleCreditCheckLoad);
    document.title = 'Verizon Wireless';
    document.onreadystatechange = () => {
      if (document.readyState === 'complete') {
        this.performPreFetch();
      }
    };
    this.props.showCart(false);
    this.props.creditCheckFailReload();
    if (isPreorder() && !isLoggedIn()) {
      this.props.getShippingDetailsFromApi('preOrderNSE', this.props.cartDetails);
    }
    updateUrl();
    const data = {
      pageName: 'creditcheck',
    };
    if (!isLoggedIn() && pdcAEMCheck()) {
      this.props.updatePdc(data);
    }
    store.dispatch({ type: 'CREDIT_CHECK_API_CLEAR', response: false });
    store.dispatch({ type: 'CEF_CREDIT_CHECK_ERROR', response: false, errorMessage: null });
    store.dispatch({ type: 'UPDATE_API_STATUS', response: 'IN_PROGRESS' });
    const { cradleThrottleList } = store.getState().contactInfo;
    if (this.props.universalProfileCreationStatus === 'success') {
      eventDispatcher('sendData', {
        name: '',
        data: {
          page: {
            contentFragments: 'Your My Verizon account was created successfully',
            name: 'creditcheck',
          },
        },
        svars: {
          evar22: 'Account creation success - professional setup',
          evar64: 'shell account fwa',
          evar221: 'shell acc fwa',
          evar220: cradleThrottleList,
        },
      });
    } else if (this.props.universalProfileCreationStatus === 'error') {
      eventDispatcher('sendData', {
        name: '',
        data: {
          page: {
            contentFragments: 'Account not created',
            name: 'creditcheck',
          },
        },
        svars: {
          evar13: 'Account not created',
          evar22: 'Account creation fail - professional setup',
          evar64: 'shell account fwa',
          evar221: 'shell acc fwa',
          evar220: cradleThrottleList,
        },
      });
      // updatePageFragments('Account not created');
    }
  }

  handleCreditCheckLoad = () => {
    const pageName = getUrlName(window.location.href);
    const markerValue = `${pageName}:ui:${getChannelId()}:${getFlowType()}:render`;

    if (window?.performance?.measure) {
      window.performance.measure(markerValue);
    }
  };

  componentWillUnmount() {
    window.removeEventListener('load', this.handleCreditCheckLoad);
    // when createProfile call is done, banner gets displayed, register it as banner displayed if user won't click close button in banner.
    if (this.props.universalProfileCreationStatus) this.props.universalProfileBannerDisplayed();
  }

  componentDidUpdate() {
    if (document.readyState === 'complete') {
      callPerformanceMeasure();
    }
    if (!this.state.invokeTagging && this.props.cartDetails?.apiStatus === 'COMPLETED') {
      this.props.invokeTaggingAPI();
      this.setState({ invokeTagging: true });
    }
  }

  triggerSubmit = (context) => {
    const { personalInfoSubmit } = context;
    if (personalInfoSubmit) {
      // TODO isFunc
      personalInfoSubmit();
    }
  };

  performPreFetch = () => {
    if (!getPrefetch()) {
      return;
    }
    const ComponentToPreload = lazyWithPreload(() => import(/* webpackPrefetch: true */ '../../ReviewOrderPage/RedesignVDS3.0/index'));
    if (typeof ComponentToPreload?.preload === 'function') ComponentToPreload.preload();
  };

  getUniVersalProfileCreationBannerProps = () => {
    // TODO: Remove defaultBannerMessages once Aem updated with new content
    // const defaultBannerMessages = {
    //   success: {
    //     title: 'Your My Verizon account was created successfully.',
    //     subtitle: "You'll receive an email to verify your email address.",
    //   },
    //   error: {
    //     title: 'Account not created',
    //     subtitle:
    //       "We're sorry but we couldn't create your My Verizon account at this time. You can still continue with your order and create your account later.",
    //   },
    // };
    const { universalProfileCreationStatus, universalProfileCreationBannerMessages } = this.props;
    return {
      type: universalProfileCreationStatus,
      title: universalProfileCreationBannerMessages?.[universalProfileCreationStatus]?.title,
      subtitle: universalProfileCreationBannerMessages?.[universalProfileCreationStatus]?.subtitle,
      onCloseButtonClick: this.props.universalProfileBannerDisplayed,
      // TODO:  add a condition to show if create api is triggered
      renderIf: !!(!this.props.isUniversalProfileSuccessBannerDisplayed && universalProfileCreationStatus),
    };
  };

  render() {
    const { retrieveCartAPIStatus, creditBtnText } = this.props;
    const type = viewport();
    const components = this.childComponents;
    const creditCheckComponents = components.filter(
      (item) => !(item.key.indexOf('/miniCartDueToday') >= 0 || item.key.indexOf('/miniCartDueMonthly') >= 0),
    );
    const miniCartComponents = components.filter(
      (item) => item.key.indexOf('/miniCartDueToday') >= 0 || item.key.indexOf('/miniCartDueMonthly') >= 0,
    );
    const isVisible = this.props.cartDetails ? this.props.cartDetails.isCartVisible : '';
    const eidQuestionnaire = this.props.creditReviewSuccessResponse?.eidQuestionnaire;
    const creditApprovalStatus = this.props.creditReviewSuccessResponse?.creditApprovalStatus;
    let isEidData = false;

    if (creditApprovalStatus !== 'AP' && eidQuestionnaire?.numOfQuestions > 0) {
      isEidData = true;
    }
    const isEid =
      (eidQuestionnaire && isEidData) ||
      (this.props?.eidQuestionsFromCreditStatus &&
        this.props?.eidQuestionsFromCreditStatus?.numOfQuestions &&
        this.props?.eidQuestionsFromCreditStatus?.numOfQuestions > 0);
    const notificationProps = {
      renderIf: false,
      title: '',
      type: 'warning',
      serviceInfo: '',
      subtitle: '',
    };
    if (this.props.creditCheckError && !this.props.ccInvalidCaseError) {
      notificationProps.renderIf = true;
      notificationProps.title = renderHTML(this.props.creditCheckNtfyMsg || commonErrors?.defaultMessage);
    } else if (this.props.ccInvalidCaseError) {
      notificationProps.renderIf = this.props.ccInvalidCaseError;
      notificationProps.title = renderHTML("<p>Looks like a transaction was started on another device. Start a new transaction to continue.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a class='transactionLink' onClick='window.redirectToHomePage()'> Start new order</a></p>");
   
    } else if (this.props.creditCheckApiError) {
      notificationProps.renderIf = this.props.creditCheckApiError;
      notificationProps.title = this.props.notifyMessage || commonErrors?.defaultMessage;
      notificationProps.serviceInfo = this.props?.creditCheckServiceDetails ? this.props?.creditCheckServiceDetails : null;
    }
    if (retrieveCartAPIStatus === 'IN_PROGRESS') {
      showLoader();
    }
    return (
      <ContextWrapper>
        <Notification {...notificationProps} />
        <Notification {...this.getUniVersalProfileCreationBannerProps()} />
        <FWAContainer topBufferAuto enableLiveSupport title={this.props.title}>
          <Row>
            <Col colSizes={{ mobile: 4, tablet: 12, desktop: 8 }} className={isMobile() ? '' : 'onlyTopMargin'}>
              <div>{creditCheckComponents}</div>
            </Col>
            <Col colSizes={{ mobile: 4, tablet: 4, desktop: 4 }} className={isMobile() || isTablet() ? 'hideForMobile' : ''}>
              {isDesktopResolution() && (
                <MiniCart
                  miniCartComponents={miniCartComponents}
                  // showCartStatus={(iscartVisibleVal) => this.props.showCart(iscartVisibleVal)}
                  iscartVisible={isVisible}
                  topMarginStyle={146}
                />
              )}
              {isDesktopResolution() && !isEid && (
                <Margin top="20px">
                  <PersonalInfoConsumer>
                    {(personalInfo) => (
                      <Button
                        width={isTablet() && !isDesktopResolution() ? '150px' : '100%'}
                        disabled={!personalInfo?.getCTAStatus()}
                        onClick={() => this.triggerSubmit(personalInfo)}
                      >
                        {personalInfo?.agreementStatus ? this.props.ctaName || 'Run credit check' : this.props.ctaDisabledLabel}
                      </Button>
                    )}
                  </PersonalInfoConsumer>
                </Margin>
              )}
              {window.innerWidth > '768' && type === 'desktop' && (
                <>
                  <div id="eidSubmitCTA" />
                  <StyledVdsRow mTop="16px" mLeft="5px">
                    <Body size="medium">{creditBtnText}</Body>
                  </StyledVdsRow>
                </>
              )}
            </Col>
          </Row>
        </FWAContainer>
      </ContextWrapper>
    );
  }
}

CreditCheck.propTypes = {
  pageName: PropTypes.string,
  invokeTaggingAPI: PropTypes.func,
  ctaDisabledLabel: PropTypes.string.isRequired,
};
